import { render, staticRenderFns } from "./DhxCalendar.vue?vue&type=template&id=565d564a"
import script from "./DhxCalendar.vue?vue&type=script&lang=js"
export * from "./DhxCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports